import React from 'react';

const FormText = React.forwardRef(({type, label, value, setValue, error, placeholder = '', maxLength, insertValue = '', insertValues = [], onBlur, disabled = false, readOnly = false}, ref) => {
	if (placeholder === '') {
		placeholder = label;
	}

	if (!maxLength) {
		maxLength = 255;
	}

	const normalizedInsertValues = Array.isArray(insertValues)
		? insertValues.filter((item) => item !== '')
		: insertValue !== ''
			? [insertValue]
			: [];

	const handleInsertValue = (insertAction) => {
		const insertActionStr = `${insertAction}`;
		if ((insertActionStr.startsWith('+') || insertActionStr.startsWith('-')) && insertActionStr.length > 1) {
			const valueStr = `${value}`.trim();
			const currentValue = valueStr === '' ? 0 : parseFloat(valueStr.replace(',', '.'));
			const delta = parseFloat(insertActionStr.replace(',', '.'));

			if (!Number.isNaN(currentValue) && !Number.isNaN(delta)) {
				setValue(`${currentValue + delta}`);
				return;
			}
		}

		setValue(insertActionStr);
	};

	const showMeta = label !== '' || error !== '' || normalizedInsertValues.length > 0;
	const canInsertValue = !disabled && !readOnly;

	return (
		<div className={`input-div${error !== '' ? ' has-error' : ''}`}>
			{showMeta ? (
				<div className="input-meta">
					<div className="input-meta-left">
						{label !== '' ? <div className="input-label">{label}</div> : ''}
						{canInsertValue ? normalizedInsertValues.map((insertAction) => (
							<button type="button" className="input-insert" onClick={() => handleInsertValue(insertAction)} key={`${insertAction}`}>
								{insertAction}
							</button>
						)) : null}
					</div>
					{error !== '' ? <div className="input-error">{error}</div> : ''}
				</div>
			) : ''}
			<div className="input-control">
				<input className="input-text" type={type} maxLength={maxLength} placeholder={placeholder} ref={ref} value={value} onChange={(e) => setValue(e.target.value)} onBlur={onBlur} disabled={disabled} readOnly={readOnly} />
			</div>
		</div>
	);
});

export default FormText;
